import React, { useEffect } from "react";
// import liff from "@line/liff";

import Logo from "../../assets/images/png/logo-circle.png";
// import TextLogo from "../../assets/images/png/text-logo.png";
import BGImage from "../../assets/images/png/bg.png";

import "./style.css";

// import { MainStore } from "core/store";
import { Button, Divider, Image } from "antd";
import { useNavigate } from "react-router-dom";

import liff from "@line/liff";
import ComingSoon from "components/coming-soon";

export default function Login({ is_caddy, is_comming }) {
  // const { setIsLoading, setUserData } = useContext(MainStore);
  const navigator = useNavigate();

  function onLogin(login_type) {
    navigator(`${login_type === 0 ? `/caddy/register` : `/golfer/register`}?login_type=${login_type}&is_login=true`);
  }

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.omise.co/omise.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.OmiseCard.configure({
        publicKey: "pkey_test_62ynnl11q7kediq719o",
        currency: "THB",
      });
    };
  }, []);

  const handleCreateSource = () => {
    window.OmiseCard.open({
      amount: 10000, // จำนวนเงินในสกุล THB
      currency: "THB", // สกุลเงิน
      defaultPaymentMethod: "mobile_banking", // วิธีการชำระเงิน
      otherPaymentMethods: ["mobile_banking"], // วิธีการชำระเงินอื่นๆ ที่สามารถเลือกได้
      onCreateTokenSuccess: (nonce) => {
        // console.log("Token Created:", nonce);
        alert(nonce);

        // ส่ง nonce ไปยัง server
        fetch(`${process.env.REACT_APP_API_URL}/bank-charge`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ omiseSource: nonce }), // ส่ง nonce เป็น omiseSource
        })
          .then((res) => res.json()) // แปลงคำตอบเป็น JSON
          .then((data) => {
            if (data.uri) {
              // เปิด URL สำหรับการยืนยันการชำระเงิน (ใช้ authorize_uri)
              window.location.href = data.uri; // เปิด URL ในแท็บปัจจุบัน
              // หรือหากต้องการเปิดในแท็บใหม่
              // window.open(data.uri, '_blank');
            } else {
              alert("เกิดข้อผิดพลาดในการสร้าง URL");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            alert("Error: " + JSON.stringify(err)); // แจ้งผู้ใช้เมื่อเกิดข้อผิดพลาด
          });
      },
      onFormClosed: () => {
        // console.log("Payment form closed");
      },
    });
  };

  useEffect(() => {
    if (!is_caddy && process.env.REACT_APP_IS_DEVELOPMENT === "false")
      setTimeout(() => {
        liff.closeWindow();
      }, 2000);
  }, []);

  return !is_caddy && process.env.REACT_APP_IS_DEVELOPMENT === "false" ? (
    <ComingSoon />
  ) : (
    <div className={`login-container ${!is_caddy ? "login-golfer" : ""}`} style={{ padding: "0px 50px" }}>
      {/* <div>
        <h2>Omise Mobile Banking Payment</h2>
        <button onClick={handleCreateSource}>Pay with KBank</button>
      </div> */}

      <div>
        <img alt="logo" src={Logo} width={250} style={{ marginTop: 40 }} />
      </div>
      <Divider style={{ margin: 0 }} />
      <b style={{ fontSize: 20 }}>เข้าสู่ระบบ / ลงทะเบียน</b>
      {is_caddy ? (
        <Button type="primary" style={{ position: "relative", zIndex: 999, width: "70%", height: 45, color: "white", fontSize: 18, backgroundColor: "rgb(0, 153, 81)" }} onClick={() => onLogin(0)}>
          สำหรับแคดดี้
        </Button>
      ) : (
        <Button type="primary" style={{ position: "relative", zIndex: 999, width: "70%", height: 45, color: "white", fontSize: 18, backgroundColor: "rgb(0, 153, 81)" }} onClick={() => onLogin(1)}>
          สำหรับนักกอล์ฟ
        </Button>
      )}

      <div style={{ position: "fixed", zIndex: 0, bottom: 0, left: 0, opacity: 0.5 }}>
        <Image width="100%" height={150} preview={false} src={BGImage} style={{ filter: "brightness(0) saturate(100%) invert(77%) sepia(67%) saturate(395%) hue-rotate(87deg) brightness(91%) contrast(85%)" }} />
      </div>
    </div>
  );
}
